<template>

  <v-container fluid>
    <modal-import-deals :dialog = "dialog" @close = "dialog =false"></modal-import-deals >
    <modal-delete :dialog = "dialogDelete" @close = "dialogDelete =false; deleteIndex = -1;" @confirm = "deleteDeal" ></modal-delete>
    <v-row class="mx-4">
      <div class="text-h3" :class="`blue-grey--text text--darken-2`" color="">
        {{labelPlural}}
        <v-progress-circular
          v-if="!loaded"
          indeterminate
          color="secondary"
        ></v-progress-circular>
      </div>
   
      <v-spacer></v-spacer>
      <v-btn @click="dialog =true" class="primary"> Importar</v-btn>
      
      <v-btn @click="newDeal" class="primary">  Novo {{labelSingular}}</v-btn>
    </v-row>

    <v-container style="max-width: 1800px">
      <v-card>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th style="max-width: 50px" class="text-left">Remover</th>
                <th style="max-width: 50px" class="text-left">Código</th>
                <th class="text-left">Data de criação</th>
                <th class="text-left">Cliente</th>
                <!-- <th class="text-left">Potência</th> -->

                <th class="text-left">Abrir</th>
              </tr>
            </thead>
            <tbody>
              <tr
                style="height: 100px"
                v-for="(deal, index) in deals"
                :key="index"
              > 
                <td style="max-width: 50px">
                  <v-btn
                    class="secondary"
                    style="max-width: 100%"
                    @click="showDialogDelete(index)"
                  >
                   <!-- @click="deleteDeal(deal.id, index)" -->
                    <v-icon>mdi-delete</v-icon></v-btn
                  >
                </td>
                <td style="max-width: 50px">{{ deal.id }}</td>
                <td style="max-width: 10px">
                  <span v-date-format="deal.createdAt"></span>
                </td>

                <td style="max-width: 150px">{{ deal.contactName }}</td>
                <!-- <td>
    
                </td> -->
                <td>
                  <v-btn @click="editDeal(deal.id)" class="primary">
                    <v-icon>mdi-pencil</v-icon></v-btn >
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>
    </v-container>
  </v-container>
  <!-- </v-card> -->
</template>

<script>
import hebelApi from '../../../../libraries/hebel/hebelApi';
import ModalImportDeals from '../../components/modals/ModalImportDeals'
import ModalDelete from '../../components/modals/ModalDelete.vue'
export default {
  name: "Home",
  props: [],
  components:{
      ModalImportDeals,ModalDelete
  },
  data() {
    return {
      loaded: true,
      dialog:false,
      dialogDelete:false,
       deleteIndex:-1,
      user: {},
      contactName: "",
      deals: [],
      stageId: 116490,
      pipelineId: 27289,
      loading: false,
      quantity: 10,
      quantities: [1, 10, 50, 100, 1000],
     
      stages: [],
    };
  },

  computed:{
    labelSingular:function(){
      return  window.style? window.style.deals.label.singular:'Negócio' 
    },
      labelPlural:function(){
      return window.style? window.style.deals.label.plural:'Negócios'
    }
  },
  async created() {
    this.user = this.$session.get("user");
  },
  async mounted() {
    this.deals = await hebelApi.deals.getAll();
  },

  methods: {
    showDialogDelete(index){
        this.deleteIndex = index;
        this.dialogDelete =true;
    },
    deleteDeal() {
      if(this.deleteIndex !== -1){
        var deal = this.deals[this.deleteIndex];
        hebelApi.deals.delete(deal.id);
        this.deals.splice(this.deleteIndex , 1);
      }
      this.dialogDelete = false;
    },
    newDeal() {
      this.$router.push("/deal");
    },

    editDeal(dealId){
      this.$router.push("/deal/"  +dealId );
    },
    async changeClient() {
      this.loading = true;
      this.deals = await this.$ploomes.deals(
        this.user,
        this.stageId,
        this.quantity,
        this.contactName
      );
      this.loading = false;
      this.$forceUpdate();
    },

    async changePipeline() {
      // alert("changePipeline")
      this.loading = true;
      this.stages = await this.$ploomes.stages(this.pipelineId);
      if (this.stages.length > 0) {
        this.stageId = this.stages[0].Id;
      }
      this.deals = await this.$ploomes.deals(
        this.user,
        this.stageId,
        this.quantity,
        this.contactName
      );
      this.loading = false;

      this.$forceUpdate();
    },
    async changeStage() {
      //alert("changeStage")
      this.loading = true;
      this.deals = await this.$ploomes.deals(
        this.user,
        this.stageId,
        this.quantity,
        this.contactName
      );
      this.loading = false;
      this.$forceUpdate();
    },
    getColor(calories) {
      if (calories > 400) return "red";
      else if (calories > 200) return "orange";
      else return "green";
    },
    openDeal(dealId) {
      this.$router.push("/deal/" + dealId);
    },
    test() {
      alert("test");
    },
    complete(index) {
      this.list[index] = !this.list[index];
    },
  },
};
</script>

<style scoped>
.labelValue {
  display: block;
  width: 120px;
  margin: auto;
  text-align: center;
}
.cardLabel {
  position: absolute;
  right: 10px;
  top: 20px;
  height: 60px;
  width: 240px;
  background-color: #4c6563;
  border-radius: 15px;
}
table {
  border: none !important;
}
</style>
